import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { IspmHttpClient } from '@ispm/core/services/ispm-http-client';
import { Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { DynamicApiService } from '../../../../app/export/services/dynamic-api.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import { takeUntil } from 'rxjs/operators';
import { RouterManagerService } from '@ispm/core/services/router-manager.service';


@Component({
  selector: 'gen-attach-report-template-to-test',
  templateUrl: './attach-report-template-to-test.component.html',
  styleUrls: ['./attach-report-template-to-test.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('attach-report-template-to-test')
export class LinkReportTemplateComponent implements OnInit, OnDestroy, IWidgetItem {

  public _formConfig: Array<any>;
  public widgetFormInstance: FormGroup;
  private _widgetFormInstanceSubmitted: boolean;

  public widgetPayload: any;
  private destroyed$: Subject<any> = new Subject();
  public inputConfig = [];
  widgetUpdateValueCallback: (value) => void;
  widgetSubmitStatusValueCallback: (value: boolean) => void;
  public listenToDataChange = true;
  public formData: any;
  private submitUri = 'reporttemplate/link';
  public fileName: any;
  private test: any;

  constructor(
    private _ispmHttpClient: IspmHttpClient,
    private _notificationMessageService: NotificationMessageService,
    private _changeDetector: ChangeDetectorRef,
    private _dynamicApiService: DynamicApiService,
    private _routerManagerService: RouterManagerService
  ) {
  }

  ngOnInit() {
  }

  set widgetData(widgetData: any) {
    this.formData = widgetData;
    if (this.formData) {
      this._changeDetector.markForCheck();
    }

  }

  set widgetConfig(widgetConfig) {

    this.widgetPayload = widgetConfig.widgetPayload;
    this._formConfig = this.widgetPayload.formConfig;
  }

  public get widgetFormInstanceSubmitted() {
    return this._widgetFormInstanceSubmitted;
  }

  public formUpdate(form) {
    this.test = form.test;
    this._changeDetector.markForCheck();
  }

  public set widgetFormInstanceSubmitted(widgetFormInstanceSubmitted: boolean) {
    this._widgetFormInstanceSubmitted = widgetFormInstanceSubmitted;
    this._changeDetector.markForCheck();
  }

  public linkReportTemplate() {
      const body = {
        testId : this.test.id,
        templateId: this.formData.templateId || this._routerManagerService.queryParameters?.templateId // queryparameters was used in case of preview linking
      };

      this._ispmHttpClient.put(this.submitUri, body)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(
        result => {
          this._dynamicApiService.setReloadWorklistStatus(true);
          this._notificationMessageService.success('Template attached to test successfully');
          console.log('Linking of Report Template succeeded', result);
          this.widgetSubmitStatusValueCallback.apply(this, [false]);
        },
        error => {
          this.widgetSubmitStatusValueCallback.apply(this, [false]);
          this._notificationMessageService.error('Failed to link template to Test' + this.getErrorMessage(error.error));
          console.log('Failed to link template to Test error', error);
        }
      );
    this._changeDetector.markForCheck();
  }

  private getErrorMessage(message: string) {
    const messages = message.split(':');
    return messages[messages.length - 1];
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this._changeDetector.detach();
  }
}


